import { useGetRiskMatrix } from "@/entities/risk-matrix";
import { useContextIntervention } from "@/features/Interventions/Details/InterventionContext";

export const useRiskMatrixFromIntervention = () => {
  const intervention = useContextIntervention();
  const riskMatrixId = intervention?.risk_matrix_id;
  const riskMatrixVersion = intervention?.risk_matrix_version;

  return useGetRiskMatrix(riskMatrixId, riskMatrixVersion);
};
